// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-palette-preview {
  background: #000000;
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/GradientPalettePreview/GradientPalettePreview.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kBAAA;AACJ","sourcesContent":[".gradient-palette-preview {\n  background: #000000;\n  border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
